import { defineComponent } from "vue";

export default defineComponent({
    name: "DirectionsComponent",
    props: ["directions"],
    methods: {
        isDisabled(field: string): boolean {
            return field == "" || field == null;
        }
    }
})